/**
 * Extract Spotify content ID and type from various URL formats
 * @param {string} url - Spotify URL
 * @returns {{type: string, id: string}|null} Content type and ID or null if invalid
 */
export function extractSpotifyContent(url) {
  if (!url || typeof url !== 'string') return null;

  try {
    const urlObj = new URL(url);

    // Must be a Spotify domain
    if (!urlObj.hostname.includes('spotify.com')) {
      return null;
    }

    // Handle open.spotify.com/TYPE/ID or open.spotify.com/embed/TYPE/ID
    const pathParts = urlObj.pathname.split('/').filter(Boolean);

    // Remove 'embed' if present
    if (pathParts[0] === 'embed') {
      pathParts.shift();
    }

    // Valid types: track, album, playlist, artist, episode, show
    const validTypes = ['track', 'album', 'playlist', 'artist', 'episode', 'show'];
    const type = pathParts[0];
    const id = pathParts[1]?.split('?')[0]; // Remove query params

    if (validTypes.includes(type) && id) {
      return { type, id };
    }

    return null;
  } catch (error) {
    return null;
  }
}

/**
 * Convert any Spotify URL to embed format
 * @param {string} url - Spotify URL
 * @returns {string|null} Embed URL or null if invalid
 */
export function convertToSpotifyEmbedUrl(url) {
  const content = extractSpotifyContent(url);
  if (!content) return null;

  return `https://open.spotify.com/embed/${content.type}/${content.id}`;
}

/**
 * Validate if URL is a valid Spotify URL
 * @param {string} url - URL to validate
 * @returns {boolean} True if valid Spotify URL
 */
export function isValidSpotifyUrl(url) {
  return extractSpotifyContent(url) !== null;
}
